<div>
    <div class="text-center text-2xl">
        {{'section.notification-wizard.select_canal' | translate}}
    </div>

    <div class="w-full h-full border-slate-200 text-lg">


        <div class="flex flex-col flex-auto">
            <ng-container
                *ngIf="canals && (canals?.length > 0 || canals?.length > 0)">
                <div class="p-6 md:p-8 space-y-8">
                    <ng-container *ngIf="canals?.length > 0">
                        <div class="flex flex-wrap text-center justify-center">
                            <ng-container *ngFor="let canal of canals">
                                <div class="flex flex-col w-40 h-40 m-4 p-4 shadow rounded-2xl cursor-pointer bg-card hover:scale-110 hover:bg-slate-100"
                                     (click)="save(canal)">
                                    <div class="flex flex-col flex-auto justify-center text-center text-lg font-medium">
                                        <span>{{canal.name}}</span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </ng-container>

        </div>

    </div>
</div>
